import React, { createContext, useContext, useEffect, useState } from 'react';
import { Preferences } from '@capacitor/preferences';
import axios from 'axios';
import { apiUrl } from '../components/config';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Funzione per recuperare token e utente dalle Preferences e impostare lo stato
    const initializeUser = async () => {
        try {
            const token = (await Preferences.get({ key: 'token' })).value;
            const storedUser = (await Preferences.get({ key: 'user' })).value;

            if (token && storedUser) {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
            } else if (token) {
                // Se c'è il token ma non l'utente, fai una richiesta API per ottenerlo
                const response = await axios.get(`${apiUrl}/api/auth/profile`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
                await Preferences.set({ key: 'user', value: JSON.stringify(response.data) }); // Cache user
            } else {
                console.log('Nessun token trovato, utente non autenticato.');
            }
        } catch (error) {
            console.error('Errore nel recupero del profilo utente:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        initializeUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, loading }}>
            {children}
        </UserContext.Provider>
    );
};
